import clsx from "clsx";
import Button from "@/components/ui/button";
import Dialog from "@/components/ui/dialog/Dialog";
import DialogCommonContent from "@/components/ui/dialog/DialogCommonContent";
import { DESIGN_SAVE_DIALOG } from "@/const/dialogMessage";
import useDesignSaveDialog from "./DesignSaveDialog.hook";
import styles from "./DesignSaveDialog.module.scss";

type Props = {
	bodyId: string | undefined;
	disabled: boolean;
};

/**
 * 保存ダイアログ コンポーネント
 * @returns {JSX.Element} 保存ダイアログ コンポーネント
 */
export default function DesignSaveDialog(props: Props) {
	const { bodyId, disabled } = props;
	const { isDialogOpen, onDialogChange, onSaveButtonClick } =
		useDesignSaveDialog({
			bodyId,
		});
	const { message, applyMessage } = DESIGN_SAVE_DIALOG;

	return (
		<Dialog
			title="パーツの保存"
			open={isDialogOpen}
			onOpenChange={onDialogChange}
			TriggerComponent={
				<Button
					className={clsx(
						styles.showModalBtn,
						disabled && styles.disabled,
					)}
					disabled={disabled}
				>
					保存
				</Button>
			}
			ContentComponent={
				<DialogCommonContent
					message={message}
					applyMessage={applyMessage}
					onClick={onSaveButtonClick}
				/>
			}
		></Dialog>
	);
}
